<template>
  <v-card :color="ui.cardColor" dark :max-width="ui.cardMaxWidth" :max-height="ui.cardMaxHeight">
    <v-card-title>
      <v-icon large left :color="ui.iconColor"> account_balance </v-icon>
      <span :class="ui.textHeadline"> Company Access </span>
    </v-card-title>

    <v-card-text class="ml-2">
      <div :class="ui.textDescription">
        Review new company requests and other admin level requests.
      </div>
    </v-card-text>

    <v-card-actions>
      <v-list-tile class="grow">
        <Search v-if="
        this.licenceOK &&
        this.licenceOKCompanyAccess &&
        this.userOK
        "
        :data="{title: 'Company Access', tag: 'C1'}"/>
        <v-spacer/>
        <GetAccessListPage :data="{tag: 'G1', tagd: 'U1', tags: 'C1', size:'flat'}"
        v-if="this.licenceOK && this.userOK"/>
        <v-btn :color="ui.colorWarning" flat dark
        v-if="!this.licenceOK || !this.userOK">
          <v-icon left>
            info
          </v-icon>
          Restricted Use
        </v-btn>
      </v-list-tile>
    </v-card-actions>
  </v-card>
</template>

<script>
import apptheme from "@/frame/theme/mixins/apptheme.js";
import licenceFunctions from "@/admin/functions/mixins/licenceFunctions.js";
import adminFunctions from "@/admin/functions/mixins/adminFunctions.js";
import Search from "@/data/search/components/Search";
import GetAccessListPage from "@/support/access/components/GetAccessListPage";

export default {
  mixins: [apptheme, licenceFunctions, adminFunctions],
  components: {
    Search,
    GetAccessListPage
  },
  data() {
    return {
      valid: true
    };
  }
};
</script>
